import { client } from "api";
import { User } from "features/auth/types/user";

export type GetUserByIdRequest = { userId: string };

export type GetUserByIdResponse = User;

export const getUserById = ({ userId }: GetUserByIdRequest): Promise<GetUserByIdResponse> =>
  client.get<GetUserByIdResponse>(`/user/${userId}`).then((res) => res.data);
